import React, { ReactNode } from "react"

interface IProps {
    children: ReactNode,
}

const FormActionButtonsSection: React.FC<IProps> = ({ children, ...props }) => {

    return(
        <div className="form-action-buttons-section">
            <div className="content-of-form-action-buttons-section">
                {children}
            </div>
        </div>
    )
}
export default FormActionButtonsSection